import { useTranslation } from 'hooks/useTranslation';
import { useRef } from 'react';
import { formatCurrency } from 'utils/currency';

type Props = {
  price: number;
  discountedPriceEuros?: number;
  deal?: boolean;
  locale: string;
  triggerPopover: (finalPrice: number, element: HTMLElement | null) => void;
  isStartingFromPrice?: boolean;
};

const PackagePrice = ({
  price,
  discountedPriceEuros,
  deal,
  locale,
  triggerPopover,
  isStartingFromPrice,
}: Props): JSX.Element => {
  const ref = useRef<HTMLElement | null>(null);
  const { t } = useTranslation();

  const finalPrice =
    deal && discountedPriceEuros ? discountedPriceEuros : price;

  return (
    <>
      {isStartingFromPrice && <div>{t('from').toLowerCase()}</div>}
      <span
        ref={ref}
        className="font-bold text-2xl underline cursor-pointer"
        onClick={() => {
          triggerPopover(finalPrice, ref.current);
        }}
      >
        {formatCurrency(finalPrice, 'EUR', locale)}
      </span>
    </>
  );
};

export default PackagePrice;
